/**
 * Registers / outlets: selector de terminal de caja por tienda.
 */

function lsKeyRegister(tiendaId) {
	return `poskn_register_id_t${tiendaId || 0}`;
}
function lsKeyRegisterName(tiendaId) {
	return `poskn_register_nombre_t${tiendaId || 0}`;
}

function getTiendaId(win) {
	if (win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id != null && win.posknTiendaSeleccionada.id !== '') {
		return parseInt(win.posknTiendaSeleccionada.id, 10) || 0;
	}
	return 0;
}

function getSelectedRegisterName(win) {
	if (win.posknRegisterSeleccionado && win.posknRegisterSeleccionado.nombre) {
		return String(win.posknRegisterSeleccionado.nombre);
	}
	try {
		return localStorage.getItem(lsKeyRegisterName(getTiendaId(win))) || '';
	} catch (e) {
		return '';
	}
}

function persistRegisterSelection(win, id, nombre) {
	const tid = getTiendaId(win);
	try {
		localStorage.setItem(lsKeyRegister(tid), String(id));
		if (nombre) localStorage.setItem(lsKeyRegisterName(tid), String(nombre));
		// Compat legacy (sin namespace): limpiar para no mezclar tiendas.
		localStorage.removeItem('poskn_register_id');
		localStorage.removeItem('poskn_register_nombre');
	} catch (e) {
		/* ignore */
	}
	win.posknRegisterSeleccionado = { id, nombre: nombre || '', tienda_id: tid };
	if (typeof win.posknUpdateConnectionStatus === 'function') {
		win.posknUpdateConnectionStatus();
	}
}

function getSelectedRegisterId(win) {
	const tid = getTiendaId(win);
	const fromObj = win.posknRegisterSeleccionado && win.posknRegisterSeleccionado.id;
	if (fromObj && (!win.posknRegisterSeleccionado.tienda_id || win.posknRegisterSeleccionado.tienda_id === tid)) {
		return parseInt(fromObj, 10) || 0;
	}
	try {
		return parseInt(localStorage.getItem(lsKeyRegister(tid)) || 0, 10) || 0;
	} catch (e) {
		return 0;
	}
}

function clearRegisterForTienda(win) {
	win.posknRegisterSeleccionado = null;
	try {
		localStorage.removeItem(lsKeyRegister(getTiendaId(win)));
		localStorage.removeItem(lsKeyRegisterName(getTiendaId(win)));
	} catch (e) {
		/* ignore */
	}
}

function highlightRegisterSelector($, on) {
	const box = $('#register-selector-compacto');
	if (!box.length) return;
	if (on) {
		box.css({ outline: '2px solid #E65100', borderRadius: '4px' });
		$('#register-selector').focus();
	} else {
		box.css({ outline: '', borderRadius: '' });
	}
}

function initRegisterEvents(win, $) {
	if (win._posknRegistersBound) return;
	win._posknRegistersBound = true;

	$(document).on('change', '#register-selector', function onRegisterChange() {
		const id = parseInt($(this).val(), 10) || 0;
		if (id > 0) win.seleccionarRegister(id);
	});
}

export function attachRegistersGlobals(win, $) {
	initRegisterEvents(win, $);

	win.posknRegisterSeleccionado = win.posknRegisterSeleccionado || null;
	win._posknRegistersList = win._posknRegistersList || [];
	win.posknClearRegisterSelection = () => clearRegisterForTienda(win);

	win.posknRequireRegisterSelected = function posknRequireRegisterSelected(silent) {
		const registers = win._posknRegistersList || [];
		if (registers.length <= 1) return true;
		if (getSelectedRegisterId(win) > 0) {
			highlightRegisterSelector($, false);
			return true;
		}
		if (!silent && typeof win.mostrarNotificacion === 'function') {
			win.mostrarNotificacion('Selecciona un terminal (🖥️ Caja) en el panel izquierdo', 'warning');
		}
		highlightRegisterSelector($, true);
		return false;
	};

	win.renderRegisterSelector = function renderRegisterSelector(data) {
		const container = $('#register-selector-compacto');
		const select = $('#register-selector');
		if (!select.length) return;

		const registers = (data && data.registers) || [];
		win._posknRegistersList = registers;
		const tid = getTiendaId(win);
		const selectedId = parseInt(
			(data && data.selected_id) || localStorage.getItem(lsKeyRegister(tid)) || 0,
			10,
		);

		if (registers.length <= 1) {
			if (registers.length === 1) {
				const reg = registers[0];
				persistRegisterSelection(win, reg.id, reg.nombre);
				container.html(`<span class="poskn-select-label" title="${reg.nombre}">🖥️ ${reg.nombre}</span>`);
				if (selectedId !== reg.id && typeof win.seleccionarRegister === 'function') {
					win.seleccionarRegister(reg.id, true);
				}
			} else {
				container.hide();
			}
			return;
		}

		container.show();
		let html = '<option value="">-- Elegir caja --</option>';
		registers.forEach((reg) => {
			const sel = reg.id === selectedId ? ' selected' : '';
			html += `<option value="${reg.id}"${sel}>${reg.nombre}</option>`;
		});
		select.html(html);

		const current = registers.find((r) => r.id === selectedId);
		if (current) {
			persistRegisterSelection(win, current.id, current.nombre);
			select.val(String(current.id));
		} else {
			win.posknRegisterSeleccionado = null;
			select.val('');
		}
	};

	win.cargarRegisters = function cargarRegisters() {
		const tiendaId = getTiendaId(win);
		const cfg = win.POSKN_API_CONFIG || {};
		const useRest = cfg.useRest !== false;

		const done = (response) => {
			if (response && response.success) {
				win.renderRegisterSelector(response.data);
			}
		};

		if (useRest && win.POSKN && win.POSKN.api && typeof win.POSKN.api.getRegisters === 'function') {
			win.POSKN.api.getRegisters(tiendaId || 0).then(done);
			return;
		}

		$.ajax({
			url: cfg.ajaxUrl || 'pos-ajax.php',
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_get_registers',
				nonce: win.posNonce || cfg.posNonce || '',
				tienda_id: tiendaId,
			},
			success: done,
		});
	};

	win.seleccionarRegister = function seleccionarRegister(registerId, silent) {
		const id = parseInt(registerId, 10) || 0;
		if (id <= 0) return;

		const cfg = win.POSKN_API_CONFIG || {};
		const tiendaId = getTiendaId(win);
		const apply = (response) => {
			if (!response || !response.success) {
				if (!silent && typeof win.mostrarNotificacion === 'function') {
					const msg =
						(response && response.data) ||
						'No se pudo cambiar de caja (¿terminal de otra tienda?)';
					win.mostrarNotificacion(typeof msg === 'string' ? msg : 'No se pudo cambiar de caja', 'error');
				}
				return;
			}
			const nombre = response.data.nombre || '';
			persistRegisterSelection(win, id, nombre);
			highlightRegisterSelector($, false);
			$('#register-selector').val(String(id));
			if (!silent && typeof win.cargarEstadoCaja === 'function') {
				win.cargarEstadoCaja();
			}
		};

		if (cfg.useRest !== false && win.POSKN?.api?.selectRegister) {
			win.POSKN.api.selectRegister(id).then(apply);
			return;
		}

		$.ajax({
			url: cfg.ajaxUrl || 'pos-ajax.php',
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_select_register',
				nonce: win.posNonce || cfg.posNonce || '',
				register_id: id,
				tienda_id: tiendaId,
			},
			success: apply,
			error() {
				apply({ success: false });
			},
		});
	};

	$(() => {
		setTimeout(() => win.cargarRegisters(), 600);
	});

	win.posknGetRegisterLabel = () => getSelectedRegisterName(win);
}
